import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class AboutContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{}
        }
        

    }

    componentDidMount()
    {
         this.setState({loading:0})
           
    }


    render()
    { 
        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
  <div class="about-area inc-video default-padding">
        <div class="container">
            <div class="row">
              
                <div class="about-content">
                    <div class="col-md-6">
                        <div class="thumb">
                            <img src={this.props.content[5].image} alt={this.props.content[5].title} />  
                        </div>
                    </div>
                    <div class="col-md-6 info-content">
                        <h4>{this.props.content[5].title}</h4>
                        <h1><div  dangerouslySetInnerHTML={{ __html: this.props.content[5].subtitle}} /></h1> 
                        <div  dangerouslySetInnerHTML={{ __html: this.props.content[5].description}} />  
                    </div>
                </div>
                
            </div>
            <div class="row">
              
              <div class="about-content">
                 
                  <div class="col-md-6 info-content">
                      <h4>{this.props.content[9].title}</h4>
                      <h1><div  dangerouslySetInnerHTML={{ __html: this.props.content[9].subtitle}} /></h1> 
                      <div  dangerouslySetInnerHTML={{ __html: this.props.content[9].description}} />  
                  </div>
                  <div class="col-md-6">
                      <div class="thumb">
                          <img src={this.props.content[9].image} alt={this.props.content[9].title} /> 
                      </div>
                  </div>
              </div>
              
          </div>
        </div>
    </div>

    <div class="choseus-area about-area bg-dark text-light">
        <div class="container-full">
            <div class="row">
                <div class="content-box">
                    <div class="col-md-6 thumb bg-cover"  style={{backgroundImage: `url(${this.props.content[6].image})`}}  ></div>
                    <div class="col-md-6 info">
                        
                        <h2>{this.props.content[6].title}</h2>
                        <div  dangerouslySetInnerHTML={{ __html: this.props.content[6].description}} />  
                    </div>
                </div>
            </div>
        </div>
    </div>
        <br />
        <br />
        </div>
       

    );
 
    }
}

export default AboutContent;